import { useRef } from 'react';
import { Field } from '@shopify/react-form';
import gettext, { pgettext } from '@sdk/lang/gettext';
import { PersonaPickerOption } from '@sdk/components/forms/personaPickers/PersonaPicker/personaPicker.types';
import { GroupedPersonaPicker } from '@sdk/components/forms/personaPickers/GroupedPersonaPicker/GroupedPersonaPicker';

import ModalRow from '@web/timesheets/CreateTimesheetModal/components/rows/ModalRow/ModalRow';
import {
  FieldContainer,
  EllipsisContainer,
} from '@web/timesheets/CreateTimesheetModal/components/rows/ModalRow/modalRow.styles';
import LocationIconSvg from '@web/assets/svg/Icons/32/location-gray.svg';

type Props = {
  locationField: Field<PersonaPickerOption[]>;
  options: PersonaPickerOption[];
};
const LocationRow = ({ locationField, options }: Props) => {
  const fieldRef = useRef<HTMLInputElement>(null);
  return (
    <ModalRow label={gettext('Location')} icon={LocationIconSvg}>
      <EllipsisContainer ref={fieldRef} width={fieldRef?.current?.offsetWidth}>
        <FieldContainer>
          <GroupedPersonaPicker
            onSelectedItemsChange={locationField.onChange}
            options={options}
            selectedItems={locationField.value}
            placeholder={pgettext('Always singular', 'Add location')}
            showTagIcons
            showTagSubtitles={false}
            showSearchIcon={false}
            maxItemsToSelect={1}
            hasError={Boolean(locationField.error?.length)}
          />
        </FieldContainer>
      </EllipsisContainer>
    </ModalRow>
  );
};

export default LocationRow;
